import Translator from 'translator';
import { Map } from 'immutable';

import icons from 'data/common/icons';

export default new Map({
    logsFhe: {
        key: 0,
        label: Translator.translate('fhe.menuItem'),
        path: 'fhe',
        right: 'logging_fhe',
        Png: icons.fhe,
    },
    logsMyFhe: {
        key: 1,
        label: Translator.translate('myfhe.menuItem'),
        path: 'myfhe',
        right: 'logging_myfhe',
        Png: icons.myfhe,
    },
    logsFHEPool: {
        key: 2,
        label: Translator.translate('fhepool.menuItem'),
        path: 'fhepool',
        right: 'logging_fhepool',
        Png: icons.fhepool,
    },
    logsCocoon: {
        key: 3,
        label: Translator.translate('cocoon.menuItem'),
        path: 'cocoon',
        right: 'logging_cocoon',
        Png: icons.cocoon,
    },
    logsFHEConnect: {
        key: 4,
        label: Translator.translate('fheconnect.menuItem'),
        path: 'fheconnect',
        right: 'logging_fheconnect',
        Png: icons.fheconnect,
    },
    logsHoming: {
        key: 5,
        label: Translator.translate('homing.menuItem'),
        path: 'homing',
        right: 'logging_homing',
        Png: icons.homing,
    },
    logsLacin: {
        key: 6,
        label: Translator.translate('lacin.menuItem'),
        path: 'lacin',
        right: 'logging_lacin',
        Png: icons.lacin,
    },
    logsDomalisa: {
        key: 7,
        label: Translator.translate('domalisa.menuItem'),
        path: 'domalisa',
        right: 'logging_domalisa',
        Png: icons.domalisa,
    },
    logsAccesshabitat: {
        key: 8,
        label: Translator.translate('accesshabitat.menuItem'),
        path: 'accesshabitat',
        right: 'logging_accesshabitat',
        Png: icons.accesshabitat,
    },
    logsMaestro: {
        key: 9,
        label: Translator.translate('maestro.menuItem'),
        path: 'maestro',
        right: 'logging_maestro',
        Png: icons.maestro,
    },
    logsWeezeo: {
        key: 10,
        label: Translator.translate('weezeo.menuItem'),
        path: 'weezeo',
        right: 'logging_weezeo',
        Png: icons.weezeo,
    },
    logsNiceenergie: {
        key: 10,
        label: Translator.translate('niceenergie.menuItem'),
        path: 'niceenergie',
        right: 'logging_niceenergie',
        Png: icons.niceenergie,
    },
    logsMghabitat: {
        key: 10,
        label: Translator.translate('mghabitat.menuItem'),
        path: 'mghabitat',
        right: 'logging_mghabitat',
        Png: icons.mghabitat,
    },
    logsInogreen: {
        key: 10,
        label: Translator.translate('inogreen.menuItem'),
        path: 'inogreen',
        right: 'logging_inogreen',
        Png: icons.inogreen,
    },
});



// WEBPACK FOOTER //
// ./environments/logging/common/subMenuData.js